<div class="dealer-info" *ngIf="dealer">
  <div class="d-flex">
    <div>
      <div class="dealer-name text-bold">
        {{ dealer.name }}
        <span class="see-more pointer-hover underline" (click)="seeMore = !seeMore">
          {{ seeMore ? "ver menos" : "ver mais" }}
        </span>
      </div>

      <div class="dealer-info-item" *ngIf="dealer.city">
        {{ dealer.city }}/{{ dealer.uf }}
      </div>

      <div *ngIf="seeMore">
        <div class="dealer-info-item">{{ dealer.cpfCnpj }}</div>
        <div class="dealer-info-item" *ngFor="let email of dealer.emails">
          {{ email }}
        </div>
        <div class="dealer-info-item" *ngFor="let phone of dealer.phoneNumbers">
          {{ phone }}
        </div>
      </div>

      <div class="dealer-info-item" *ngIf="dealer.stats.lastActionDate">
        Último acesso: {{dealer.stats.lastActionDate | date : 'dd/MM/yyyy HH:mm'}}
      </div>
      <div class="dealer-info-item" *ngIf="dealer.stats.views">
        <span style="font-weight: bold">{{ dealer.stats.views | number}}</span> visualizações
      </div>
      <div class="dealer-info-item" *ngIf="dealer.stats.bids">
        <span style="font-weight: bold">{{ dealer.stats.bids | number}}</span> ofertas
      </div>

      <div class="dealer-info-item" *ngIf="dealer.stats.personalizedOffers">
        <span style="font-weight: bold">{{ dealer.stats.personalizedOffers | number }}</span>
        ofertas personalizadas
      </div>
      <div class="dealer-info-item" *ngIf="dealer.stats.acceptedPersonalizedOffers">
        <span style="font-weight: bold">{{
          dealer.stats.acceptedPersonalizedOffers | number
        }}</span>
        ofertas personalizadas aceitas
      </div>

      <div class="dealer-info-item" *ngIf="dealer.stats.rejectedPersonalizedOffers">
        <span style="font-weight: bold">{{
          dealer.stats.rejectedPersonalizedOffers | number
        }}</span>
        ofertas personalizadas rejeitadas
      </div>
      <div class="dealer-info-item" *ngIf="dealer.stats.favorites">
        <span style="font-weight: bold">{{ dealer.stats.favorites | number}}</span> favoritos
      </div>
    </div>
  </div>
</div>